import React, { useMemo } from 'react';
import { Text, makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import { EntitySelectionBeachIcon } from './media/icons';

const useEntitySelectionNoResultsViewStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '8px',
    padding: '16px',
    height: '100%',
  },
  title: {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
  },
  description: {
    marginBottom: '16px',
    color: tokens.colorNeutralForeground3,
  },
});
interface EntitySelectionNoResultsViewProps {
  i18n: any;
  hasNoEntityTypeInAccount : boolean;
  entityType?: string; // required if hasNoEntityTypeInAccount  is true, otherwise not needed
}

export const EntitySelectionNoResultsView = (props: EntitySelectionNoResultsViewProps) => {
  const {
    entityType,
    i18n,
    hasNoEntityTypeInAccount = false,
  } = props;
  const styles = useEntitySelectionNoResultsViewStyles();


  const description = useMemo(() => {
    if (hasNoEntityTypeInAccount) {
      return _TL_('There are no {{entityType}} in the account yet.');
    }
    return _TL_('No results match your search. Please try a different search.');
  }, [hasNoEntityTypeInAccount]);

  return (
    <div className={mergeClasses(styles.root, 'entity-selection-menu-no-results')}>
      <EntitySelectionBeachIcon />
      <Text size={300} className={mergeClasses(styles.title, 'copilot-no-results-title')}>
        {i18n.getString(_TL_('No results found.'))}
      </Text>
      <Text size={100} className={mergeClasses(styles.description, 'copilot-no-results-description')}>
        {i18n.getString(description, { entityType })}
      </Text>
    </div>
  );
};
